import brianMcCracken from './images/Brian-Round-400x400.png';
import measureSupport from './images/Dwayne_Indow_Support4x4.svg';
import eboniWashington from './images/Eboni-Round-400x400.png';
import emilyJackson from './images/Emily-Round-400x400.png';
import fitSpecialists from './images/fit-specialists.jpg';
import hannahHendrickson from './images/Hannah-Round-400x400.png';
import jamesWerth from './images/James-Round-400x400.png';
import kayaCarvey from './images/Kaya-Round-400x400.png';
import martinLewin from './images/Martin-Round-400x400.png';
import reedNicholson from './images/Reed-Round-400x400.png';
import ryanLibby from './images/Ryan-Round-400x400.png';
import tylerJohnson from './images/Tyler-Round-400x400.png';

const personMap = new Map([
	[
		'fit-specialists',
		{
			bio: 'Indow Fit Specialists are trained to answer all of your questions, get you the best pricing, and  ensure you get the right products and right fit for your space. We care about understanding exactly what’s going on with your windows and want to help solve your comfort, noise, and energy waste concerns.',
			image: fitSpecialists,
			calendar: {
				domain: 'fsconsult',
			},
			questions: [
				{
					answer:
						'Our team of Fits Specialists can help answer any questions you have about Indow inserts and make sure their an ideal fit for your window situation. Schedule an appointment to learn more and get a customized estimate for your space.',
				},
			],
		},
	],
	[
		'james-werth',
		{
			image: jamesWerth,
			firstName: 'James',
			lastName: 'Werth',
			title: 'Fit Specialist',
			hometown: 'Salina, KS',
			hobbies: 'Painting and consuming as many podcasts as I can',
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'Being able to talk with people from across the country and playing a small part in their story is a true joy.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer:
						'The people who work here are great, as is the energy and excitement of being part of a growing company. I also love that I get to work with people all over North America.',
				},
			],
			calendar: {
				domain: 'fs-james',
			},
		},
	],
	[
		'martin-lewin',
		{
			image: martinLewin,
			firstName: 'Martin',
			lastName: 'Lewin',
			hometown: 'NYC',
			hobbies: 'Photography, gardening, being Grandpa.',
			title: 'Fit Specialist',
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'I love helping people solve problems. When I can help someone solve a problem with a high-quality, affordable solution, it makes my day.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer:
						'The people who work here are great, as is the energy and excitement of being part of a growing company. I also love that I get to work with people all over North America.',
				},
			],
			calendar: {
				domain: 'fs-martin',
			},
		},
	],
	[
		'kaya-carvey',
		{
			image: kayaCarvey,
			firstName: 'Kaya',
			lastName: 'Carvey',
			title: 'Fit Specialist',
			hometown: 'Bursa, Turkey',
			hobbies:
				'Board sports, yoga, watching nature documentaries, cooking for friends',
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'I love meeting new people and getting small glimpses into their lives. A lot of the time people are in transitional life stages when they’re looking into Indow, be it buying a new home or getting ready to have kids, and I love being able to assist in that process.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer:
						'The emphasis Indow places on caring for the environment is very important to me, but the best part is the very supportive group of people I work with!',
				},
			],
			calendar: {
				domain: 'fs-kaya',
			},
		},
	],
	[
		'reed-nicholson',
		{
			image: reedNicholson,
			firstName: 'Reed',
			lastName: 'Nicholson',
			title: 'Fit Specialist',
			hometown: 'West Linn, OR',
			hobbies:
				'I’ve coached baseball on the West Linn High school staff since summer of 2012. I’ve been the head coach of the freshman baseball program since 2014.',
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'I enjoy having different conversations with so many different people every day. It’s rewarding to know that we’re helping make their homes more comfortable, and customers can feel good about the fact they accomplished it through work they did themselves.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer:
						'I enjoy that everyone in the company has a voice, and we’re constantly trying to find solutions to make life easier for our customers. We have a fantastic group of people here who care about each other as well as the people purchasing our product. It makes going to work every day very easy.',
				},
			],
			calendar: {
				domain: 'fs-reed',
			},
		},
	],
	[
		'hannah-hendrickson',
		{
			title: 'Fit Specialist',
			firstName: 'Hannah',
			lastName: 'Hendrickson',
			image: hannahHendrickson,
			hometown: 'La Center, WA',
			hobbies: 'Cooking, Running, Painting',
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'I love finding solutions to difficult problems. Nothing makes me happier than cracking those tough nuts.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer: 'Bringing peace and comfort to people’s homes every day.',
				},
			],
			calendar: {
				domain: 'fs-hannah',
			},
		},
	],
	[
		'brian-mccracken',
		{
			title: 'Fit Specialist',
			firstName: 'Brian',
			lastName: 'McCracken',
			hometown: 'Davenport, IA',
			hobbies:
				'Making music, illustration, costume design, conspiracy theories',
			image: brianMcCracken,
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer: 'Hearing all the different stories.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer:
						'I love working for a startup that seeks to make a difference in the world through conscious capitalism. I love the people, the environment, and the balance of creativity and discipline. Most importantly, however, I love making a difference in peoples’ lives by listening to their stories and providing solutions.',
				},
			],
			calendar: {
				domain: 'fs-brian',
			},
		},
	],
	[
		'eboni-washington',
		{
			title: 'Fit Specialist',
			firstName: 'Eboni',
			lastName: 'Washington',
			hobbies: 'Painting, diving, reading and watching movies',
			hometown: 'Charleston, IL',
			image: eboniWashington,
			questions: [
				{
					question:
						'What do I find most rewarding about interacting with customers: ',
					answer:
						'In general, I enjoy the ability to speak with new people every day and learn about their experiences.  I find fulfillment in being able to help our customers solve their problems.',
				},
				{
					question: 'What is the best part of working at Indow:',
					answer:
						'Being surrounded by professionals who not only care about the future of their own careers, but also the future of the company as a whole.',
				},
			],
			calendar: {
				domain: 'fs-eboni',
			},
		},
	],
	[
		'emily-jackson',
		{
			title: 'Fit Specialist',
			firstName: 'Emily',
			lastName: 'Jackson',
			hobbies: 'Gardening, cooking, being mom of two daughters',
			hometown: 'Southside, VA',
			image: emilyJackson,
			questions: [
				{
					question:
						'What do I find most rewarding about interacting with customers: ',
					answer:
						'I enjoy meeting new people everyday and and the conversations we have to help bring more comfort into their lives.',
				},
				{
					question: 'What is the best part of working at Indow:',
					answer:
						"I love our company's vision and that I get to help play a part in helping out our environment.",
				},
			],
			calendar: {
				domain: 'fs-emily',
			},
		},
	],
	[
		'tyler-johnson',
		{
			title: 'Commercial Sales and Business Development Manager',
			firstName: 'Tyler',
			lastName: 'Johnson',
			hometown: 'Portland, OR',
			hobbies: 'Soccer, Snowboarding, Travelling',
			image: tylerJohnson,
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'I love being a consultant for my clients.I want to learn what the core problem you’re addressing and find a solution that works best for your situation. Whether you use one of our interior window inserts or another solution.',
				},
				{
					question: 'What’s the best part of working at Indow?',
					answer:
						'I love introducing people to a product they might not have known before and showing how effective it can make their existing windows.',
				},
			],
			calendar: {
				domain: 'fs-tyler',
			},
		},
	],
	[
		'ryan-libby',
		{
			title: 'Director of Inside Sales',
			firstName: 'Ryan',
			lastName: 'Libby',
			hometown: 'Buffalo, NY',
			hobbies: 'Bicycling, journaling, home improvement projects',
			image: ryanLibby,
			questions: [
				{
					question:
						'What do you find most rewarding about interacting with customers?',
					answer:
						'I love digging into the story behind each project.  Knowing that our inserts are playing a role in the bigger picture for what a property is for the residents is deeply rewarding.',
				},
				{
					question: "What's the best part of working at Indow?",
					answer:
						"I've been here for over 8 years now, and it's been spent working along with people committed to growing and improving things every day.",
				},
			],
			calendar: {
				domain: 'fs-ryan',
			},
			bio: 'I help team members who are working directly with customers get better at providing results to more people.',
		},
	],
	[
		'measure-support',
		{
			noindex: true,
			firstName: 'Measure Support',
			image: measureSupport,
			calendar: {
				domain: 'smtechsupport',
			},
			bio: 'Once you have received our Laser Measure Kit, please schedule an appointment with Measure Support if you require any assistance. ',
			questions: [
				{
					answer:
						"Whether you've run into issues with your Laser Measurement Device, need some guidance on getting accurate dimensions with a tape measure, or have concerns about entering information into the MBI portal, we're here to help!",
				},
				{
					answer:
						'We can guide you step-by-step to resolve any problems you might encounter during the measurement process and put your mind at ease. Schedule an appointment using the calendar above or contact us at the following:',
				},
			],
			contact: {
				phone: '503-284-2260',
				email: 'comfort@indowwindows.com',
			},
		},
	],
]);

export default personMap;
